import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
  className?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  action,
  className = "",
}: SectionHeadingProps) {
  return (
    <div className={`mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between ${className}`}>
      <div className="max-w-2xl">
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-2 font-label text-xs uppercase tracking-[0.2em] text-accent-500">
            <span className="h-px w-6 bg-accent-500/60"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="text-xl font-bold text-foreground-50 md:text-2xl">{title}</h2>
        {desc && <p className="mt-2 text-sm leading-relaxed text-foreground-400">{desc}</p>}
      </div>
      {action}
    </div>
  );
}